// Code generated by protoc-gen-family-http. DO NOT EDIT.
// source: calendar.proto

import type { AxiosInstance } from 'axios';
import { buildPath, unwrapEnvelope, Envelope } from '../contracts-runtime';
import { AppleCalendarConnectionRequest, AppleCalendarConnectionResponse, AppleCalendarDisconnectRequest, AppleCalendarManualSyncRequest, AppleCalendarSetupRequest, AppleCalendarSetupResponse, AppleCalendarSyncResponse, CalendarConnection, CalendarConnectionListResponse, CalendarDisconnectResponse, CalendarEvent, CalendarEventListResponse, CalendarSyncPullRequest, CalendarSyncPullResponse, CalendarSyncPushRequest, CalendarSyncPushResponse, CalendarSyncRequest, CalendarSyncResponse, ConvertCalendarEventToTodoRequest, CreateCalendarEventRequest, GoogleAuthCallbackResponse, GoogleAuthInitResponse, GoogleCalendarAuthRequest, GoogleCalendarCallbackRequest, GoogleCalendarListResponse, GoogleCalendarSyncResponse, GoogleCalendarWebhookRequest, GoogleCalendarWebhookResponse, ListCalendarEventsRequest, ListSubcalendarsRequest, Subcalendar, SubcalendarListResponse, UpdateCalendarConnectionSelectionRequest, UpdateSubcalendarRequest } from "./calendar";
import { Empty } from "./google/protobuf/empty";
import { Todo } from "./todo";

// ─── CalendarService ──────────────────────────────────

export const CalendarService_CreateCalendarEventRoute = "POST /api/v1/calendar/events";
export const CalendarService_ListCalendarEventsRoute = "GET /api/v1/calendar/events";
export const CalendarService_CalendarSyncRoute = "POST /api/v1/calendar/sync";
export const CalendarService_GoogleCalendarAuthRoute = "GET /api/v1/calendar/google/auth";
export const CalendarService_GoogleCalendarCallbackRoute = "GET /api/v1/calendar/google/callback";
export const CalendarService_GoogleCalendarSyncRoute = "POST /api/v1/calendar/google/sync";
export const CalendarService_GoogleCalendarWebhookRoute = "POST /api/v1/calendar/google/webhook";
export const CalendarService_GoogleCalendarDisconnectRoute = "POST /api/v1/calendar/google/disconnect";
export const CalendarService_ConvertCalendarEventToTodoRoute = "POST /api/v1/calendar/events/{id}/to-todo";
export const CalendarService_AppleCalendarSetupRoute = "POST /api/v1/calendars/setup";
export const CalendarService_AppleCalendarConnectionRoute = "POST /api/v1/calendars/connections";
export const CalendarService_ListCalendarConnectionsRoute = "GET /api/v1/calendars/connections";
export const CalendarService_AppleCalendarManualSyncRoute = "POST /api/v1/calendars/{id}/sync";
export const CalendarService_AppleCalendarDisconnectRoute = "DELETE /api/v1/calendars/{id}";
export const CalendarService_ListGoogleCalendarsRoute = "GET /api/v1/calendar/google/calendars";
export const CalendarService_UpdateCalendarConnectionSelectionRoute = "POST /api/v1/calendars/{id}/selection";
export const CalendarService_ListSubcalendarsRoute = "GET /api/v1/calendar-subcalendars";
export const CalendarService_UpdateSubcalendarRoute = "POST /api/v1/calendar-subcalendars/{id}";
export const CalendarService_SyncPushCalendarEventsRoute = "POST /api/v1/calendar/events/sync/push";
export const CalendarService_SyncPullCalendarEventsRoute = "POST /api/v1/calendar/events/sync/pull";

export const calendarService = {
  async createCalendarEvent(client: AxiosInstance, req: CreateCalendarEventRequest): Promise<CalendarEvent> {
    const path = buildPath("/api/v1/calendar/events", {});
    const res = await client.post<Envelope<unknown>>(path, CreateCalendarEventRequest.toJSON(req));
    return CalendarEvent.fromJSON(unwrapEnvelope(res.data));
  },
  async listCalendarEvents(client: AxiosInstance, req: ListCalendarEventsRequest): Promise<CalendarEventListResponse> {
    const path = buildPath("/api/v1/calendar/events", {});
    const res = await client.get<Envelope<unknown>>(path, { params: ListCalendarEventsRequest.toJSON(req) });
    return CalendarEventListResponse.fromJSON(unwrapEnvelope(res.data));
  },
  async calendarSync(client: AxiosInstance, req: CalendarSyncRequest): Promise<CalendarSyncResponse> {
    const path = buildPath("/api/v1/calendar/sync", {});
    const res = await client.post<Envelope<unknown>>(path, CalendarSyncRequest.toJSON(req));
    return CalendarSyncResponse.fromJSON(unwrapEnvelope(res.data));
  },
  async googleCalendarAuth(client: AxiosInstance, req: GoogleCalendarAuthRequest): Promise<GoogleAuthInitResponse> {
    const path = buildPath("/api/v1/calendar/google/auth", {});
    const res = await client.get<Envelope<unknown>>(path, { params: GoogleCalendarAuthRequest.toJSON(req) });
    return GoogleAuthInitResponse.fromJSON(unwrapEnvelope(res.data));
  },
  async googleCalendarCallback(client: AxiosInstance, req: GoogleCalendarCallbackRequest): Promise<GoogleAuthCallbackResponse> {
    const path = buildPath("/api/v1/calendar/google/callback", {});
    const res = await client.get<Envelope<unknown>>(path, { params: GoogleCalendarCallbackRequest.toJSON(req) });
    return GoogleAuthCallbackResponse.fromJSON(unwrapEnvelope(res.data));
  },
  async googleCalendarSync(client: AxiosInstance, req: Empty): Promise<GoogleCalendarSyncResponse> {
    const path = buildPath("/api/v1/calendar/google/sync", {});
    const res = await client.post<Envelope<unknown>>(path, Empty.toJSON(req));
    return GoogleCalendarSyncResponse.fromJSON(unwrapEnvelope(res.data));
  },
  async googleCalendarWebhook(client: AxiosInstance, req: GoogleCalendarWebhookRequest): Promise<GoogleCalendarWebhookResponse> {
    const path = buildPath("/api/v1/calendar/google/webhook", {});
    const res = await client.post<Envelope<unknown>>(path, GoogleCalendarWebhookRequest.toJSON(req));
    return GoogleCalendarWebhookResponse.fromJSON(unwrapEnvelope(res.data));
  },
  async googleCalendarDisconnect(client: AxiosInstance, req: Empty): Promise<CalendarDisconnectResponse> {
    const path = buildPath("/api/v1/calendar/google/disconnect", {});
    const res = await client.post<Envelope<unknown>>(path, Empty.toJSON(req));
    return CalendarDisconnectResponse.fromJSON(unwrapEnvelope(res.data));
  },
  async convertCalendarEventToTodo(client: AxiosInstance, req: ConvertCalendarEventToTodoRequest): Promise<Todo> {
    const path = buildPath("/api/v1/calendar/events/{id}/to-todo", { id: String(req.id) });
    const res = await client.post<Envelope<unknown>>(path, ConvertCalendarEventToTodoRequest.toJSON(req));
    return Todo.fromJSON(unwrapEnvelope(res.data));
  },
  async appleCalendarSetup(client: AxiosInstance, req: AppleCalendarSetupRequest): Promise<AppleCalendarSetupResponse> {
    const path = buildPath("/api/v1/calendars/setup", {});
    const res = await client.post<Envelope<unknown>>(path, AppleCalendarSetupRequest.toJSON(req));
    return AppleCalendarSetupResponse.fromJSON(unwrapEnvelope(res.data));
  },
  async appleCalendarConnection(client: AxiosInstance, req: AppleCalendarConnectionRequest): Promise<AppleCalendarConnectionResponse> {
    const path = buildPath("/api/v1/calendars/connections", {});
    const res = await client.post<Envelope<unknown>>(path, AppleCalendarConnectionRequest.toJSON(req));
    return AppleCalendarConnectionResponse.fromJSON(unwrapEnvelope(res.data));
  },
  async listCalendarConnections(client: AxiosInstance, req: Empty): Promise<CalendarConnectionListResponse> {
    const path = buildPath("/api/v1/calendars/connections", {});
    const res = await client.get<Envelope<unknown>>(path, { params: Empty.toJSON(req) });
    return CalendarConnectionListResponse.fromJSON(unwrapEnvelope(res.data));
  },
  async appleCalendarManualSync(client: AxiosInstance, req: AppleCalendarManualSyncRequest): Promise<AppleCalendarSyncResponse> {
    const path = buildPath("/api/v1/calendars/{id}/sync", { id: String(req.id) });
    const res = await client.post<Envelope<unknown>>(path, AppleCalendarManualSyncRequest.toJSON(req));
    return AppleCalendarSyncResponse.fromJSON(unwrapEnvelope(res.data));
  },
  async appleCalendarDisconnect(client: AxiosInstance, req: AppleCalendarDisconnectRequest): Promise<CalendarDisconnectResponse> {
    const path = buildPath("/api/v1/calendars/{id}", { id: String(req.id) });
    const res = await client.delete<Envelope<unknown>>(path, { params: AppleCalendarDisconnectRequest.toJSON(req) });
    return CalendarDisconnectResponse.fromJSON(unwrapEnvelope(res.data));
  },
  async listGoogleCalendars(client: AxiosInstance, req: Empty): Promise<GoogleCalendarListResponse> {
    const path = buildPath("/api/v1/calendar/google/calendars", {});
    const res = await client.get<Envelope<unknown>>(path, { params: Empty.toJSON(req) });
    return GoogleCalendarListResponse.fromJSON(unwrapEnvelope(res.data));
  },
  async updateCalendarConnectionSelection(client: AxiosInstance, req: UpdateCalendarConnectionSelectionRequest): Promise<CalendarConnection> {
    const path = buildPath("/api/v1/calendars/{id}/selection", { id: String(req.id) });
    const res = await client.post<Envelope<unknown>>(path, UpdateCalendarConnectionSelectionRequest.toJSON(req));
    return CalendarConnection.fromJSON(unwrapEnvelope(res.data));
  },
  async listSubcalendars(client: AxiosInstance, req: ListSubcalendarsRequest): Promise<SubcalendarListResponse> {
    const path = buildPath("/api/v1/calendar-subcalendars", {});
    const res = await client.get<Envelope<unknown>>(path, { params: ListSubcalendarsRequest.toJSON(req) });
    return SubcalendarListResponse.fromJSON(unwrapEnvelope(res.data));
  },
  async updateSubcalendar(client: AxiosInstance, req: UpdateSubcalendarRequest): Promise<Subcalendar> {
    const path = buildPath("/api/v1/calendar-subcalendars/{id}", { id: String(req.id) });
    const res = await client.post<Envelope<unknown>>(path, UpdateSubcalendarRequest.toJSON(req));
    return Subcalendar.fromJSON(unwrapEnvelope(res.data));
  },
  async syncPushCalendarEvents(client: AxiosInstance, req: CalendarSyncPushRequest): Promise<CalendarSyncPushResponse> {
    const path = buildPath("/api/v1/calendar/events/sync/push", {});
    const res = await client.post<Envelope<unknown>>(path, CalendarSyncPushRequest.toJSON(req));
    return CalendarSyncPushResponse.fromJSON(unwrapEnvelope(res.data));
  },
  async syncPullCalendarEvents(client: AxiosInstance, req: CalendarSyncPullRequest): Promise<CalendarSyncPullResponse> {
    const path = buildPath("/api/v1/calendar/events/sync/pull", {});
    const res = await client.post<Envelope<unknown>>(path, CalendarSyncPullRequest.toJSON(req));
    return CalendarSyncPullResponse.fromJSON(unwrapEnvelope(res.data));
  },
};

